import { TableContentHeader, TableContentProperty } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import {
  COLUMN_NAME_FORECAST_DIFF,
  ForecastDiffColumnTypes,
  ICustomerForecastDiffLastMonthSortInfo,
} from '../entities/forecastDiffLastMonth';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 内示前月差異の列の型
 */
export class ForecastDiffLastMonthService {
  public static BASE_HEADER_KEY = 'customerForecastWithDiffLastMonth';

  /**
   * テーブルのプロパティを取得する
   * @param forecastCount - 内示の数
   */
  public static getTableProperty = (forecastCount: number): TableContentProperty[] => {
    const tableProperty: TableContentProperty[] = [];
    for (let i = 0; i < forecastCount; i++) {
      for (let j = 0; j < 3; j++) {
        tableProperty.push({
          key: `${this.BASE_HEADER_KEY}-${i + 1}-${j + 1}`,
          isVariableWidth: true,
          isNarrowable: true,
          isEditable: false,
          sortOption: {
            isSortable: true,
            isAsc: true,
          },
          propertyPath: { paths: [], propertyType: 'number' },
        });
      }
    }
    return tableProperty;
  };

  /**
   * ヘッダーキーが内示前月差異のヘッダーキーかどうか
   * @param headerKey - ヘッダーキー
   */
  public static isForecastDiffHeaderKey = (headerKey: string): boolean => {
    return headerKey.startsWith(ForecastDiffLastMonthService.BASE_HEADER_KEY);
  };

  /**
   * ヘッダーキーから列のタイプを取得する
   * @param headerKey - ヘッダーキー
   */
  public static getColumnType = (headerKey: string): ForecastDiffColumnTypes => {
    // headerKeyは'customerForecastWithDiffLastMonth-x-y'の形式であり、xが何番目の内示か、yがその中の何番目の列かを示す
    const index = parseInt(headerKey.split('-')[2]) - 1;
    return COLUMN_NAME_FORECAST_DIFF[index];
  };

  /**
   * ヘッダーキーから内示のインデックスを取得する
   * @param headerKey - ヘッダーキー
   */
  public static getForecastIndex = (headerKey: string): number => {
    return parseInt(headerKey.split('-')[1]) - 1;
  };

  /**
   * ソートに必要な情報を取得する
   * @param headerContents - ヘッダーコンテンツ
   * @param headerKey - ヘッダーキー
   */
  public static getSortInfo = (
    headerContents: TableContentHeader,
    headerKey: string
  ): ICustomerForecastDiffLastMonthSortInfo | undefined => {
    if (headerKey == 'customerForecastUpdateAt') {
      return {
        sortKey: 'updateAt',
      };
    } else if (headerKey == 'ForecastForReceiptStaff') {
      return {
        sortKey: 'baseBusinessResponsibleUser',
      };
    } else if (!ForecastDiffLastMonthService.isForecastDiffHeaderKey(headerKey)) {
      return {
        sortKey: headerKey,
      };
    }

    const startYearMonth = headerContents.forecastStartYearMonth;
    if (!startYearMonth) {
      return undefined;
    }

    const forecastIndex = this.getForecastIndex(headerKey);
    const columnType = this.getColumnType(headerKey);
    let sortKey = '';
    // ソート対象の年月を取得
    const sortTargetYearMonth = DateService.getShiftedIYearMonthByMonths(startYearMonth.year, startYearMonth.month, forecastIndex);
    switch (columnType) {
      case 'lastMonthAmount':
        sortKey = 'beforeCustomerForecastAmount';
        break;
      case 'currentMonthAmount':
        sortKey = 'customerForecastAmount';
        break;
      case 'diffAmount':
        sortKey = 'forecastAmountDiffLastMonth';
        break;
    }
    return { sortTargetYearMonth, sortKey };
  };
}
